import { httpRequest } from "../../http";

export class CommandLinkAds {
  async run(organizationId: number, folderId: number, adId: number) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/content/${organizationId}/folders/${folderId}/ads/${adId}/`;

    try {
      const response = await httpRequest<any>(url, {
        method: "POST",
      });
      return response;
    } catch (error) {
      console.error("Error linking ads:", error);
      throw error;
    }
  }
}
